import { loadView } from '@/router'

export default [
  {
    path: 'zones',
    name: 'manage-zones',
    component: loadView('Application/Manage/Zones')
  }
]
